module.exports = __webpack_public_path__ + "static/media/LogViewerIcon.d8953fb0.svg";